import { render, staticRenderFns } from "./QAndA.vue?vue&type=template&id=b053d87e&"
import script from "./QAndA.vue?vue&type=script&lang=js&"
export * from "./QAndA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports